import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TimesheetService } from '@evorait/pace-core';
import { environment } from '../../environments/environment';

export const TimesheetCanActivateGuard: CanActivateFn = () => {
    if (environment.operateInMockMode) {
        return true;
    }

    const timesheetService = inject(TimesheetService);
    if (timesheetService.isTimesheetFeatureEnabled()) {
        return true;
    }

    const router = inject(Router);
    return router.createUrlTree(['/main']);
};
